module.exports = __webpack_public_path__ + "img/iosewm.png";